import { render } from "./CommerceClientShow.vue?vue&type=template&id=6f06bedf&scoped=true"
import script from "./CommerceClientShow.vue?vue&type=script&lang=js"
export * from "./CommerceClientShow.vue?vue&type=script&lang=js"

import "./CommerceClientShow.vue?vue&type=style&index=0&id=6f06bedf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f06bedf"]])

export default __exports__